import React from "react";
import { Outlet } from "react-router-dom";

/** Same radial canvas as File Manager / Analytics — presentation only, no route logic. */
const ADMIN_PAGE_BACKGROUND = {
  background:
    "radial-gradient(ellipse at top left, #dbeafe 0%, transparent 50%), radial-gradient(ellipse at top right, #e0e7ff 0%, transparent 50%), radial-gradient(ellipse at bottom center, #eff6ff 0%, transparent 60%), #f8faff",
};

export default function AdminLayout() {
  return (
    <div
      className="relative w-full min-h-screen flex flex-col border-l border-gray-200/80"
      style={ADMIN_PAGE_BACKGROUND}
    >
      <Outlet />
    </div>
  );
}
